import { z } from "zod";
export const Point2D = z.object({
    x: z.number(),
    y: z.number(),
});
